import React, { useEffect, useState } from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import { bizIG } from '../../utils/Utils';
import './InstagramPopup.css';

const STORAGE_KEY = 'risto-ig-popup-dismissed';
const SHOW_DELAY_MS = 2500;

const InstagramPopup = ({ contentLng }) => {
    const [visible, setVisible] = useState(false);
    const { title, followBtn, skipBtn, tags } = contentLng.instagramPopup;

    useEffect(() => {
        if (sessionStorage.getItem(STORAGE_KEY)) return;

        const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
        return () => clearTimeout(timer);
    }, []);

    const dismiss = () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setVisible(false);
    };

    const handleFollow = () => {
        window.open(`https://instagram.com/${bizIG}/`, '_blank', 'noopener,noreferrer');
        dismiss();
    };

    if (!visible) return null;

    return (
        <div className="ig-popup-overlay" onClick={dismiss}>
            <div className="ig-popup-card" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
                <InstagramIcon className="ig-popup-icon" />
                <p className="ig-popup-label">INSTAGRAM</p>
                <h2 className="ig-popup-title">{title}</h2>
                <span className="ig-popup-handle">@{bizIG}</span>
                <div className="ig-popup-tags">
                    {tags.map((tag) => (
                        <span key={tag} className="ig-popup-tag">{tag}</span>
                    ))}
                </div>
                <button type="button" className="ig-popup-follow-btn" onClick={handleFollow}>
                    {followBtn}
                </button>
                <button type="button" className="ig-popup-skip-btn" onClick={dismiss}>
                    {skipBtn}
                </button>
            </div>
        </div>
    );
};

export default InstagramPopup;
